var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vTable',{ref:"tabledoc",staticClass:"margin-15",attrs:{"columns":_vm.columns,"data":_vm.datalist,"size":"small","border":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }